import { DropdownItemProps } from "semantic-ui-react";
import { IRequestFeedback } from "./requestFeedback";

export interface ISRB {
    guid: string;
    serialNumber: string;
    issueDate: string;
    active: boolean;
    issuingAuthority: string;
    paperSrbLastIssueAuthority: string;
    paperSrbLastIssueDate: string;
    paperSrbLastNB: string;
    paperSrbNavigationDays: string;
    comments: string;
    crewMemberCid: string;
    crewMemberGuid: string;
    currentActiveSrbSerialNumber: string;
    requestFeedbacks: IRequestFeedback[];
    ecdbAcknowledged: boolean;
}

export const newSrbInit: ISRB = {
    guid: "",
    serialNumber: "",
    issueDate: "",
    active: true,
    issuingAuthority: "",
    paperSrbLastIssueAuthority: "",
    paperSrbLastIssueDate: "",
    paperSrbLastNB: "",
    paperSrbNavigationDays: "",
    comments: "",
    crewMemberCid: "",
    crewMemberGuid: "",
    currentActiveSrbSerialNumber: "",
    requestFeedbacks: [],
    ecdbAcknowledged: false,
};

export const srbActiveOptions: DropdownItemProps[] = [
    { key: true, text: "active", value: true },
    { key: false, text: "inactive", value: false },
];
